var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "38px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "34px",
    height: "38px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAmCAMAAACWCLnmAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEWKrsaKrsZfd4hngpRWbHszQUpNYW9FV2MZICV5mK0aISU0QksrNj2Bo7lwjaEjLDI8TFYJCwwAAAARFhkICgz///8G9QV7AAAAEXRSTlMAWJeLo9Wvu/ly+dPhZn7tybY4VkwAAAABYktHRBXl2PmjAAAAB3RJTUUH6AIUEwgpB3OvqgAAANdJREFUOMvt1MsSgyAMBVAivlBB0fz/t5YIKBklne6bjZie4jUdqhR8KaWg8btQXoOCYxfrCARlgoG0MmkpTEer/plzoH4XRDAjrfW5vgs0dcfUNRTHG04MvSga9oWJbQMT3xp6up8LA3MMWHSWHD7dn6+5sH0tRfYu9cCdUS1P5yjykZqWJo6Oi7T1Gqew8sdeZqP+AHm1PUSeIJFyZrxsSeybiB/Bff2T30j48SSC0UikSQenTvKpawVSnswaKUyV3KZOLiOQbCQSDYokzAdRy0TFP8GrPlipHMtF6a5fAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a243339916c1ea1042f0459f47fc0952.svg";
export { ForwardRef as ReactComponent };